import { useState } from 'react'
import { EventActivityParticipantEntry } from './eventActivityParticipantEntry'
import { EventActivityLinkedPlanData } from '../hooks/useEventActivityLinkedPlanData'
import { useActivityAssignmentViewModels } from '../hooks/useActivityAssignmentViewModels'
import ViewerParticipantAssignmentAbilitiesDialog from './ViewerParticipantAssignmentAbilitiesDialog'
import EncounterSummaryBlock from './EncounterSummaryBlock'
import { hasLinkedRaidPlanRefs } from './linkedPlanReveal'

type Props = {
  entry: EventActivityParticipantEntry
  activeActivities: wowaudit.EventActivity[]
  linkedPlanDataByActivityId: Map<number, EventActivityLinkedPlanData>
  isRaidPlansLoading?: boolean
}

const ViewerParticipantActivitySummary = ({
  entry,
  activeActivities,
  linkedPlanDataByActivityId,
  isRaidPlansLoading = false,
}: Props) => {
  const [openedActivityId, setOpenedActivityId] = useState<number | null>(null)
  const { activityViewModels, openableEncounters } =
    useActivityAssignmentViewModels(
      entry,
      activeActivities,
      linkedPlanDataByActivityId,
    )
  const participantName = entry.participant.primaryCharacterReference.name
  const isAssignmentCountPending =
    isRaidPlansLoading && activeActivities.some(hasLinkedRaidPlanRefs)

  return (
    <div className='flex h-full min-h-0 min-w-0 max-w-full flex-wrap content-stretch items-stretch gap-2'>
      {activityViewModels.map((viewModel) => (
        <EncounterSummaryBlock
          key={viewModel.activity.id}
          viewModel={viewModel}
          isRaidPlansLoading={isAssignmentCountPending}
          onClick={
            viewModel.isOpenable
              ? () => setOpenedActivityId(viewModel.activity.id)
              : undefined
          }
        />
      ))}
      <ViewerParticipantAssignmentAbilitiesDialog
        open={openedActivityId !== null}
        onOpenChange={(open) => {
          if (!open) setOpenedActivityId(null)
        }}
        encounters={openableEncounters}
        selectedActivityId={openedActivityId}
        onSelectActivity={setOpenedActivityId}
        participantName={participantName}
      />
    </div>
  )
}

export default ViewerParticipantActivitySummary
